/**
 * useStoryboards — fetches storyboard sprite URLs for thumbnail preview.
 * @module components/manage/VideoJS/useStoryboards
 */
import { useEffect, useState } from 'react';
import request from 'superagent';
import has from 'lodash/has';
import config from '@plone/volto/registry';
import { MEDIA_PAGE_STORYBOARDS_ROUTE } from 'volto-base-addon/constants';
import { usePathKey, withPathKeyParam } from 'volto-base-addon/helpers/pathKey';

/**
 * @param {string} parentUid - Media page UID
 * @param {Array} parentItems - Media page child items
 * @returns {{ storyboards: string[] | null }}
 */
export const useStoryboards = (parentUid, parentItems) => {
  const [storyboards, setStoryboards] = useState(null);
  const pathKey = usePathKey();

  const hasVideo = Array.isArray(parentItems)
    ? parentItems.some(
        (item) => item['@type'] === 'transcoding' && item['title'] === '360p',
      )
    : false;

  useEffect(() => {
    if (!parentUid || !hasVideo) {
      return;
    }

    let cancelled = false;

    const fetchStoryboards = async () => {
      try {
        const { body } = await request.get(
          withPathKeyParam(
            `${config.settings.publicPath}/${MEDIA_PAGE_STORYBOARDS_ROUTE}/${parentUid}`,
            pathKey,
          ),
        );
        if (!cancelled && has(body, 'storyboards')) {
          setStoryboards(body.storyboards);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('Failed to fetch storyboards:', err);
      }
    };

    fetchStoryboards();

    return () => {
      cancelled = true;
    };
  }, [parentUid, hasVideo, pathKey]);

  return { storyboards };
};

export default useStoryboards;
